import type { BadgeTone } from '@paige/ui';
import type { OpsStage, TenantState } from './types';

export const tenantStateTone: Record<TenantState, BadgeTone> = {
  trial: 'accent',
  active: 'success',
  'past due': 'danger',
  suspended: 'warning',
  closed: 'neutral',
};

export const opsStageWord: Record<OpsStage, string> = {
  intake: 'Intake',
  render: 'Render',
  ocr: 'OCR',
  split: 'Split',
  classify: 'Classify',
  extract: 'Extract',
  check: 'Check',
  handoff: 'Hand-off',
  review: 'Review',
  export: 'Export',
  learn: 'Learn',
};

export const ownerWord = {
  customer: 'Customer',
  support: 'Support',
  engineering: 'Engineering',
} as const;

/** The one line a staff role that does not read a company's people sees where they would be (StaffPolicy.SeesPeople). */
export const SHOWN_TO_SUPPORT = 'People and devices are shown to support';
